import {ComponentRegistry} from '../../components/component-registry';
import {DataApi} from '../../api/data-api/data-api';
import {AbstractGroup} from '../abstract-group';
import {EventFilter, EventSettings} from './filter';

/**
 * Event picker.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class Picker extends AbstractGroup<EventFilter, EventSettings> {
  constructor(container: HTMLElement) {
    super(container);
    this.settings.silent = true;
    this.find();
    ComponentRegistry.add('event-picker', this);
  }

  /**
   * Finds picked events.
   */
  protected find(): void {
    DataApi.instance.eventEndpoint.find(this.settings, null)
      .then(response => {
        if (this.isResultEmpty(response)) {
          this.empty();
          return;
        }
        this.notEmpty();

        let html = '';
        let i = 0;
        for (const document of response.documents) {
          const template = require('../../handlebars/templates/event/item.handlebars');
          html += template({
            document: document,
            isLast: i === response.documents.length - 1,
            iteration: i++
          });
        }
        this.update(html);

        this.emitter.emit('change', this);
      })
      .catch(e => {
        this.error(e);
      });
  }
}
